<template>
    <v-container>
        <v-row column justify-center align-center no-gutters>
            <v-col cols="12">
                <div class="map">
                    <p class="text-center">
                        <TranslatableStringComponent :tstring="{string: 'engineeredInTheUSAMadeAndSoldAllOverTheWorld'}" />
                    </p>
                    <GmapMap
                        ref="gmap"
                        :center="center"
                        :zoom="2"
                        map-type-id="terrain"
                        class="gmap"
                    >
                        <GmapMarker
                            v-for="(m, index) in locationz"
                            :key="index"
                            :position="m.position"
                            :content="m.content"
                            @click="toggleInfoWindow(m, index)"
                        />
                        <gmap-info-window
                            :options="infoOptions"
                            :position="infoWindowPos"
                            :opened="infoWinOpen"
                            @closeclick="infoWinOpen = false"
                        >
                            <div v-if="infoContent">
                                <h2 v-if="infoContent.title">
                                    {{ infoContent.title }}
                                </h2>
                                <h3 v-if="infoContent.subtitle">
                                    {{ infoContent.subtitle }}
                                </h3>
                                <div>
                                    <span v-if="infoContent.address.st_num"
                                        >{{ infoContent.address.st_num }}
                                    </span>
                                    <span v-if="infoContent.address.st_name">{{
                                        infoContent.address.st_name
                                    }}</span>
                                </div>
                                <div>
                                    <span v-if="infoContent.address.city"
                                        >{{ infoContent.address.city }},
                                    </span>
                                    <span v-if="infoContent.address.state">{{
                                        infoContent.address.state
                                    }}</span>
                                    <span v-if="infoContent.address.cnt_name"
                                        >,
                                        {{ infoContent.address.cnt_name }}</span
                                    >
                                    <span
                                        v-if="infoContent.address.country_code"
                                        >{{
                                            infoContent.address.country_code
                                        }}</span
                                    >
                                </div>
                                <div v-if="infoContent.address.phone">
                                    {{ infoContent.address.phone }}
                                </div>
                                <div v-if="infoContent.address.email">
                                    {{ infoContent.address.email }}
                                </div>
                            </div>
                        </gmap-info-window>
                    </GmapMap>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Vue from 'vue'
import * as VueGoogleMaps from 'vue2-google-maps'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue' 
Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.GOOGLE_MAPS_API_KEY,
        libraries: 'places'
    }
})
export default {
    name: 'MapLocations',
    components: {
        TranslatableStringComponent,
    },
    props: {
        // content: {
        //     type: Object,
        //     default: null
        // },
        locations: {
            type: Array,
            default: null
        }
    },
    data() {
        return {
            center: { lat: 51.507351, lng: -0.127758 },
            mapTypeId: 'terrain',
            map: null,
            infoContent: null,
            infoWindowPos: {
                lat: 0,
                lng: 0
            },
            infoWinOpen: false,
            currentMidx: null,
            // optional: offset infowindow so it visually sits nicely on top of our marker
            infoOptions: {
                pixelOffset: {
                    width: 0,
                    height: -35
                }
            },
            markers: this.locationz
        }
    },
    // mounted() {
    //     // this.initMap()
    //     this.populateLocations()
    // },
    computed: {
        locationz() {
            const locale = this.$i18n.locale
            return this.locations.map((item) => {
                return {
                    title:
                        item.title && item.title[locale]
                            ? item.title[locale]
                            : '',
                    subtitle:
                        item.subtitle && item.subtitle[locale]
                            ? item.subtitle[locale]
                            : '',
                    address: {
                        country_code: item.address.country_code,
                        email: item.address.email,
                        phone: item.address.phone,
                        st_num: item.address.st_num,
                        st_name: item.address.st_name,
                        city: item.address.city,
                        state: item.address.state,
                        cnt_name: item.address.cnt_name
                    },
                    position: {
                        lat: item.address.latitude,
                        lng: item.address.longitude
                    }
                }
            })
        }
    },
    methods: {
        // initMap() {
        //     this.$refs.gmap.$mapPromise.then((map) => {
        //         const bounds = new VueGoogleMaps.gmapApi.maps.LatLngBounds()
        //         for (const m of this.locationz) {
        //             bounds.extend(m.position)
        //         }
        //         map.fitBounds(bounds)
        //     })
        // },
        toggleInfoWindow(marker, idx) {
            this.infoWindowPos = marker.position
            this.infoContent = marker
            // check if its the same marker that was selected if yes toggle
            if (this.currentMidx === idx) {
                this.infoWinOpen = !this.infoWinOpen
            }
            // if different marker set infowindow to open and reset current marker index
            else {
                this.infoWinOpen = true
                this.currentMidx = idx
            }
        }
        // async populateLocations() {
        //     const sQuery = `*[_type == 'location' ] {...}`
        //     try {
        //         const sRes = await client.fetch(sQuery)
        //         // console.log(sRes)
        //         const locations = sRes.map((item) => {
        //             return {
        //                 title: item.title.en,
        //                 subtitle: item.subtitle.en,
        //                 address: {
        //                     country_code: item.address.country_code,
        //                     email: item.address.email,
        //                     phone: item.address.phone,
        //                     st_num: item.address.st_num,
        //                     st_name: item.address.st_name,
        //                     city: item.address.city,
        //                     state: item.address.state,
        //                     cnt_name: item.address.cnt_name
        //                 },
        //                 position: {
        //                     lat: item.address.latitude,
        //                     lng: item.address.longitude
        //                 }
        //             }
        //         })
        //         this.markers = [...this.markers, ...locations]
        //         // console.log(this.markers)
        //     } catch (error) {
        //         // console.log(error)
        //     }
        // }
    }
}
</script>
